/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductTile_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontProductGrid_user$ref: FragmentReference;
export type StorefrontProductGrid_user = {|
  +serviceId: ?string,
  +$fragmentRefs: StorefrontProductTile_user$ref,
  +$refType: StorefrontProductGrid_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontProductGrid_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductTile_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'afdf0ee6cbdf3256b81521631216ee4f';
module.exports = node;
